/*!
 * Emitever Build Your Own Kit V1.3 — isolated script.
 * Namespace: emitKitV1 (window-scoped IIFE), operates only inside
 * [data-emit-kit-v1]. No shared state, no shared JS dependency with the
 * LED System Builder (sections/kit-builder-pro.liquid) or any global theme
 * script. Safe to remove without affecting any other page.
 */
(function emitKitV1() {
  "use strict";

  var ROOT = document.querySelector("[data-emit-kit-v1]");
  if (!ROOT) return;

  var STAGE = ROOT.querySelector("[data-emit-kit-stage]");
  var DATA_EL = ROOT.querySelector("#emit-kit-v1-data");
  var CONFIG = { products: [], systemBuilderUrl: "/pages/led-system-builder" };
  try {
    CONFIG = JSON.parse(DATA_EL.textContent || "{}");
  } catch (e) {
    /* leave CONFIG as safe default */
  }

  var CATALOG = {};
  (CONFIG.products || []).forEach(function (p) {
    CATALOG[p.role] = p;
  });

  /* ---------------------------------------------------------------------
   * Small helpers
   * ------------------------------------------------------------------- */
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      if (k === "class") node.className = attrs[k];
      else if (k === "html") node.innerHTML = attrs[k];
      else if (k === "text") node.textContent = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) {
      if (c) node.appendChild(c);
    });
    return node;
  }

  function money(cents) {
    var n = Number(cents || 0) / 100;
    return "$" + n.toFixed(2);
  }

  function firstNumber(str) {
    var m = String(str || "").match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }

  function variantLengthFt(variant) {
    var opts = (variant.options || []).join(" ") + " " + (variant.title || "");
    var m = opts.match(/(\d+(?:\.\d+)?)\s*FT/i);
    return m ? parseFloat(m[1]) : null;
  }

  function variantWattage(variant) {
    var opts = (variant.options || []).join(" ") + " " + (variant.title || "");
    var m = opts.match(/(\d+(?:\.\d+)?)\s*W\b/i);
    return m ? parseFloat(m[1]) : null;
  }

  function isTwoPack(variant) {
    return /pack|2pk|2pack/i.test(variant.title || "");
  }

  function isTwentyFourVolt(variant) {
    return /24\s*V/i.test((variant.options || []).join(" ") + " " + (variant.title || ""));
  }

  /* Pick the smallest wattage variant, filtered by predicate, whose
   * usable capacity (nameplate * 0.8) covers requiredLoadWatts. Returns
   * the variant object or null. */
  function pickPowerVariant(product, requiredLoadWatts, filterFn) {
    if (!product) return null;
    var candidates = product.variants
      .filter(function (v) {
        return v.available && (!filterFn || filterFn(v));
      })
      .map(function (v) {
        var w = variantWattage(v);
        return w ? { v: v, w: w, usable: w * 0.8 } : null;
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return a.w - b.w;
      });
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].usable >= requiredLoadWatts) return candidates[i].v;
    }
    return null;
  }

  /* Pick the strip variant matching a target length tier, preferring an
   * exact/available match; falls back to the next available length and
   * flags that a substitution happened. */
  function pickStripVariant(product, targetLengthFt) {
    if (!product) return { variant: null, substituted: false };
    var sorted = product.variants
      .map(function (v) {
        return { v: v, ft: variantLengthFt(v) };
      })
      .filter(function (x) {
        return x.ft;
      })
      .sort(function (a, b) {
        return a.ft - b.ft;
      });
    var exact = sorted.find(function (x) {
      return Math.abs(x.ft - targetLengthFt) < 0.5 && x.v.available;
    });
    if (exact) return { variant: exact.v, substituted: false };
    var anyAvailable = sorted.find(function (x) {
      return x.v.available;
    });
    if (anyAvailable) return { variant: anyAvailable.v, substituted: true, actualFt: anyAvailable.ft };
    return { variant: null, substituted: false };
  }


  function iconSvg(name) {
    var icons = {
      kitchen:
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M5 10.5h22M7.5 10.5V26h17V10.5M11 15v6M21 15v6M4 6h24"/></svg>',
      bedroom:
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M5 24V12m22 12V15a4 4 0 0 0-4-4H10a5 5 0 0 0-5 5v4h22M8 11V8h7v3M5 20h22"/></svg>',
      shelves:
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M6 5v22M26 5v22M6 10h20M6 18h20M10 6v4M18 12v6M22 20v7"/></svg>',
      tv:
        '<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="5" y="7" width="22" height="15" rx="2"/><path d="M12 27h8M16 22v5"/></svg>',
      desk:
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M5 20h22M8 20v7M24 20v7M10 5h12v10H10zM16 15v5"/></svg>',
      accent:
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M7 25c4-8 8-12 18-18M10 8h5M12.5 5.5v5M22 19h5M24.5 16.5v5"/></svg>',
      diy:
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M6 24 18 12M15 7l4-2 4 4-2 4-6-6ZM5 27l5-1-4-4-1 5ZM21 19l6 6M24 16l4 4"/></svg>',
      other:
        '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M6 7h20v15H14l-6 5v-5H6z"/><path d="M11 14h.01M16 14h.01M21 14h.01"/></svg>'
    };
    return icons[name] || icons.other;
  }

  /* ---------------------------------------------------------------------
   * State
   * ------------------------------------------------------------------- */
  var STEP_ORDER = ["intro", "application", "length", "feel", "control", "connectors", "result"];

  var state = {
    step: "intro",
    application: null,
    lengthFt: null,
    lengthLabel: null,
    somethingElseText: "",
    feel: null,
    control: null,
    connectors: null,
    flags: {}
  };
  var history = [];
  var lastRenderedStep = null;

  var APPLICATIONS = [
    { id: "kitchen", icon: "kitchen", label: "Kitchen & Cabinets", sub: "Under-cabinet, toe-kick, pantry" },
    { id: "bedroom", icon: "bedroom", label: "Bedroom & Room", sub: "Ambient, cozy, accent" },
    { id: "shelves", icon: "shelves", label: "Shelves & Displays", sub: "Cases, shelves, collectibles" },
    { id: "tv", icon: "tv", label: "TV & Entertainment", sub: "Backlighting, media walls" },
    { id: "desk", icon: "desk", label: "Desk & Gaming", sub: "Ambient color or clean white light" },
    { id: "accent", icon: "accent", label: "Accent & Cove", sub: "Coves, trim, architectural lines" },
    { id: "diy", icon: "diy", label: "DIY & Custom", sub: "Prototypes, hobby builds, experiments" },
    { id: "other", icon: "other", label: "Something Else", sub: "Tell us a bit more" }
  ];

  var LENGTH_CHIPS = [
    { label: "About 6 ft", ft: 6 },
    { label: "About 12 ft", ft: 12 },
    { label: "About 16 ft", ft: 16.4 },
    { label: "About 25 ft", ft: 25 }
  ];

  var FEELS = [
    { id: "warm", label: "Warm & Cozy", sub: "2700K — soft, relaxed light", swatch: "#ffd9a0" },
    { id: "warmnatural", label: "Warm & Natural", sub: "3000K — inviting, balanced warmth", swatch: "#ffe3b8" },
    { id: "neutral", label: "Clean & Neutral", sub: "4000K — balanced, true-to-life", swatch: "#fff2df" },
    { id: "daylight", label: "Bright Daylight", sub: "5000K — crisp, energizing light", swatch: "#eef6ff" },
    { id: "tunable", label: "Adjustable White", sub: "One strip, dial in any white from cozy to crisp", swatch: "#f3e6ff" },
    { id: "colors", label: "Colors", sub: "Full-color RGB, great for accents & parties", swatch: "#ff6fb5" }
  ];

  var CONTROLS = [
    { id: "remote", label: "Remote", sub: "Handheld remote, no wiring" },
    { id: "wall", label: "Wall Control", sub: "Replaces a wall switch — needs household wiring" },
    { id: "onoff", label: "Simple On / Off", sub: "Plug in, flip the power" },
    { id: "ownpower", label: "Bring My Own Power", sub: "Battery or existing 24V DC power source" },
    { id: "notsure", label: "Not Sure", sub: "We'll pick the easiest compatible option" }
  ];

  var CONNECTOR_CHOICES = [
    { id: "none", label: "No extras", sub: "The included/basic connection pieces are enough" },
    { id: "join", label: "Join cut sections", sub: "Reconnect compatible strip sections after cutting" },
    { id: "corner", label: "Turn a 90° corner", sub: "Add an L-shaped corner connector where compatible" },
    { id: "gap", label: "Bridge a gap", sub: "Carry the run across a cabinet break or small gap" },
    { id: "notsure", label: "Not Sure", sub: "We’ll only add something when there’s a clear match" }
  ];

  var OUTDOOR_KEYWORDS = /\b(outdoor|patio|wet location|waterproof|moisture|rain|pool|exterior|deck|backyard|garden|porch|eave|soffit)\b/i;
  var VOLT48_KEYWORDS = /\b(48\s*-?\s*v(olt)?s?)\b/i;
  var BATTERY_KEYWORDS = /\b(battery|batteries|cosplay|wearable|costume|helmet|backpack|portable power|power bank)\b/i;
  var ARGB_KEYWORDS = /\b(argb|a-rgb|motherboard|rgb header|addressable|ws2812|ws2811|neopixel|pc case|gpu|computer case)\b/i;

  /* ---------------------------------------------------------------------
   * Navigation
   * ------------------------------------------------------------------- */
  function goTo(step) {
    history.push(state.step);
    state.step = step;
    render();
    STAGE.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function goBack() {
    if (!history.length) return;
    state.step = history.pop();
    render();
    STAGE.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function restart() {
    state = {
      step: "intro",
      application: null,
      lengthFt: null,
      lengthLabel: null,
      somethingElseText: "",
      feel: null,
      control: null,
      connectors: null,
      flags: {}
    };
    history = [];
    render();
    STAGE.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /* ---------------------------------------------------------------------
   * Progress bar
   * ------------------------------------------------------------------- */
  function renderProgress(currentIdx, total) {
    var wrap = el("div", { class: "emit-kit-v1__progress" });
    for (var i = 0; i < total; i++) {
      var state_ = i < currentIdx ? "done" : i === currentIdx ? "current" : "";
      wrap.appendChild(el("span", { class: "emit-kit-v1__progress-dot", "data-state": state_ }));
    }
    wrap.appendChild(el("span", { class: "emit-kit-v1__progress-label", text: "Step " + (currentIdx + 1) + " of " + total }));
    return wrap;
  }

  /* ---------------------------------------------------------------------
   * Step: Intro
   * ------------------------------------------------------------------- */
  function renderIntro() {
    var panel = el("div", { class: "emit-kit-v1__panel emit-kit-v1__hero" });
    panel.appendChild(el("p", { class: "emit-kit-v1__eyebrow", text: "Build Your Own Kit" }));
    panel.appendChild(el("h1", { class: "emit-kit-v1__title", text: "Tell us what you're lighting." }));
    panel.appendChild(
      el("p", {
        class: "emit-kit-v1__subtitle",
        text: "Answer a few questions and we'll choose the right strip, power, and controls for you, no system planning required."
      })
    );
    var notes = el("ul", { class: "emit-kit-v1__hero-notes" });
    ["Takes about a minute", "One recommended setup", "Technical matching handled for you"].forEach(function (t) {
      notes.appendChild(el("li", { text: t }));
    });
    panel.appendChild(notes);

    var row = el("div", { class: "emit-kit-v1__btn-row emit-kit-v1__center", style: "justify-content:center;" });
    var startBtn = el("button", { class: "emit-kit-v1__btn", type: "button", text: "Start Building" });
    startBtn.addEventListener("click", function () {
      goTo("application");
    });
    row.appendChild(startBtn);
    panel.appendChild(row);

    var link = el("a", {
      class: "emit-kit-v1__btn--link",
      href: CONFIG.systemBuilderUrl,
      text: "Need a professional system? Use the LED System Builder"
    });
    panel.appendChild(el("div", { class: "emit-kit-v1__center emit-kit-v1__hero-system-link", style: "margin-top:24px;" }, [link]));

    return panel;
  }

  /* ---------------------------------------------------------------------
   * Step: Application
   * ------------------------------------------------------------------- */
  function renderApplication() {
    var panel = el("div", { class: "emit-kit-v1__panel" });
    panel.appendChild(renderProgress(0, 5));
    panel.appendChild(el("h2", { class: "emit-kit-v1__title", text: "What are you lighting?" }));
    panel.appendChild(el("p", { class: "emit-kit-v1__subtitle", text: "Pick whichever fits best, this helps us tailor a few suggestions." }));

    var grid = el("div", { class: "emit-kit-v1__card-grid" });
    APPLICATIONS.forEach(function (app) {
      var pressed = state.application === app.id ? "true" : "false";
      var card = el("button", { class: "emit-kit-v1__card", type: "button", "aria-pressed": pressed }, [
        el("span", { class: "emit-kit-v1__card-icon", "aria-hidden": "true", html: iconSvg(app.icon) }),
        el("span", { class: "emit-kit-v1__card-label", text: app.label }),
        el("span", { class: "emit-kit-v1__card-sub", text: app.sub })
      ]);
      card.addEventListener("click", function () {
        state.application = app.id;
        render();
      });
      grid.appendChild(card);
    });
    panel.appendChild(grid);

    if (state.application === "other" || state.application === "diy") {
      var ta = el("textarea", {
        class: "emit-kit-v1__textarea",
        placeholder:
          state.application === "diy"
            ? "What are you building? A rough idea is enough, e.g. “a display case prototype” or “a battery-powered hobby project.”"
            : "A sentence or two is plenty, e.g. “lighting for a covered patio” or “lights for a small custom project.”"
      });
      ta.value = state.somethingElseText;
      ta.addEventListener("input", function () {
        state.somethingElseText = ta.value;
      });
      panel.appendChild(ta);
    }

    var row = el("div", { class: "emit-kit-v1__btn-row" });
    var back = el("button", { class: "emit-kit-v1__btn emit-kit-v1__btn--ghost", type: "button", text: "Back" });
    back.addEventListener("click", goBack);
    var next = el("button", { class: "emit-kit-v1__btn", type: "button", text: "Continue" });
    next.disabled = !state.application;
    next.addEventListener("click", function () {
      var text = (state.somethingElseText || "").toLowerCase();
      if (state.application === "other" || state.application === "diy") {
        state.flags.outdoor = OUTDOOR_KEYWORDS.test(text);
        state.flags.volt48 = VOLT48_KEYWORDS.test(text);
        state.flags.bringOwnPower = BATTERY_KEYWORDS.test(text);
        state.flags.argb = ARGB_KEYWORDS.test(text);
      } else {
        state.flags.outdoor = false;
        state.flags.volt48 = false;
        state.flags.bringOwnPower = false;
        state.flags.argb = false;
      }
      goTo("length");
    });
    row.appendChild(back);
    row.appendChild(next);
    panel.appendChild(row);

    return panel;
  }

  /* ---------------------------------------------------------------------
   * Step: Length
   * ------------------------------------------------------------------- */
  function renderLength() {
    var panel = el("div", { class: "emit-kit-v1__panel" });
    panel.appendChild(renderProgress(1, 5));
    panel.appendChild(el("h2", { class: "emit-kit-v1__title", text: "How much lighting do you need?" }));
    panel.appendChild(el("p", { class: "emit-kit-v1__subtitle", text: "A rough estimate works, we'll size everything from here." }));

    var row = el("div", { class: "emit-kit-v1__chip-row" });
    LENGTH_CHIPS.forEach(function (chip) {
      var pressed = state.lengthLabel === chip.label ? "true" : "false";
      var btn = el("button", { class: "emit-kit-v1__chip", type: "button", "aria-pressed": pressed, text: chip.label });
      btn.addEventListener("click", function () {
        state.lengthFt = chip.ft;
        state.lengthLabel = chip.label;
        render();
      });
      row.appendChild(btn);
    });
    panel.appendChild(row);

    var customWrap = el("div", { class: "emit-kit-v1__custom-length" });
    customWrap.appendChild(el("label", { for: "emit-kit-v1-custom-ft", text: "Custom length (ft):" }));
    var input = el("input", { type: "number", min: "1", max: "10000", step: "0.1", inputmode: "decimal", id: "emit-kit-v1-custom-ft", "aria-describedby": "emit-kit-v1-length-note" });
    if (state.lengthLabel === "Custom" && state.lengthFt) input.value = state.lengthFt;
    customWrap.appendChild(input);
    panel.appendChild(customWrap);
    panel.appendChild(el("p", { class: "emit-kit-v1__field-note", id: "emit-kit-v1-length-note", text: "Need more than 25 ft? Enter it anyway. We can compare multiple kit sections with a professionally planned system." }));

    var navRow = el("div", { class: "emit-kit-v1__btn-row" });
    var back = el("button", { class: "emit-kit-v1__btn emit-kit-v1__btn--ghost", type: "button", text: "Back" });
    back.addEventListener("click", goBack);
    var next = el("button", { class: "emit-kit-v1__btn", type: "button", text: "Continue" });
    next.disabled = !state.lengthFt;
    next.addEventListener("click", function () {
      goTo("feel");
    });

    input.addEventListener("input", function () {
      var v = parseFloat(input.value);
      if (v > 0) {
        state.lengthFt = v;
        state.lengthLabel = "Custom";
        renderChipStates(row);
        next.disabled = false;
      } else {
        state.lengthFt = null;
        next.disabled = true;
      }
    });
    navRow.appendChild(back);
    navRow.appendChild(next);
    panel.appendChild(navRow);

    return panel;
  }

  function renderChipStates(row) {
    Array.prototype.forEach.call(row.querySelectorAll(".emit-kit-v1__chip"), function (b) {
      b.setAttribute("aria-pressed", "false");
    });
  }

  /* ---------------------------------------------------------------------
   * Step: Feel
   * ------------------------------------------------------------------- */
  function renderFeel() {
    var panel = el("div", { class: "emit-kit-v1__panel" });
    panel.appendChild(renderProgress(2, 5));
    panel.appendChild(el("h2", { class: "emit-kit-v1__title", text: "What should the light feel like?" }));
    panel.appendChild(el("p", { class: "emit-kit-v1__subtitle", text: "Pick the mood you're going for." }));

    var stack = el("div", { class: "emit-kit-v1__stack" });
    FEELS.forEach(function (f) {
      var pressed = state.feel === f.id ? "true" : "false";
      var card = el("button", { class: "emit-kit-v1__feel-card", type: "button", "aria-pressed": pressed }, [
        el("span", {
          class:
            "emit-kit-v1__feel-swatch" +
            (f.id === "tunable" ? " emit-kit-v1__feel-swatch--tunable" : "") +
            (f.id === "colors" ? " emit-kit-v1__feel-swatch--colors" : ""),
          style: (f.id === "tunable" || f.id === "colors") ? "" : "background:" + f.swatch + ";",
          "aria-hidden": "true"
        }),
        el("span", { class: "emit-kit-v1__feel-copy" }, [el("strong", { text: f.label }), el("span", { text: f.sub })])
      ]);
      card.addEventListener("click", function () {
        state.feel = f.id;
        render();
      });
      stack.appendChild(card);
    });
    panel.appendChild(stack);

    var navRow = el("div", { class: "emit-kit-v1__btn-row" });
    var back = el("button", { class: "emit-kit-v1__btn emit-kit-v1__btn--ghost", type: "button", text: "Back" });
    back.addEventListener("click", goBack);
    var next = el("button", { class: "emit-kit-v1__btn", type: "button", text: "Continue" });
    next.disabled = !state.feel;
    next.addEventListener("click", function () {
      goTo("control");
    });
    navRow.appendChild(back);
    navRow.appendChild(next);
    panel.appendChild(navRow);

    return panel;
  }

  /* ---------------------------------------------------------------------
   * Step: Control
   * ------------------------------------------------------------------- */
  function renderControl() {
    var panel = el("div", { class: "emit-kit-v1__panel" });
    panel.appendChild(renderProgress(3, 5));
    panel.appendChild(el("h2", { class: "emit-kit-v1__title", text: "How would you like to power & control it?" }));
    panel.appendChild(el("p", { class: "emit-kit-v1__subtitle", text: "Choose the experience you want. We’ll match the compatible hardware behind it." }));

    var wallBlocked = state.feel === "tunable" || state.feel === "colors";

    var row = el("div", { class: "emit-kit-v1__chip-row" });
    CONTROLS.forEach(function (c) {
      var pressed = state.control === c.id ? "true" : "false";
      var unavailable = wallBlocked && (c.id === "wall" || c.id === "onoff" || c.id === "ownpower");
      var btnLabel = c.label;
      if (wallBlocked && c.id === "remote") btnLabel = "Remote — Included";
      if (unavailable) btnLabel = c.label + " — Not currently available";
      var btn = el("button", {
        class: "emit-kit-v1__chip" + (unavailable ? " emit-kit-v1__chip--unavailable" : ""),
        type: "button",
        "aria-pressed": pressed,
        text: btnLabel
      });
      if (unavailable) {
        btn.setAttribute("aria-describedby", "emit-kit-v1-control-note");
        btn.addEventListener("click", function () {
          var note = ROOT.querySelector("#emit-kit-v1-control-note");
          if (note) {
            note.textContent =
              c.label +
              " is not currently available through this guided kit path for " +
              (state.feel === "tunable" ? "Adjustable White" : "Colors") +
              ". The lighting type itself is still possible; our current all-in-one recommendation uses its included remote.";
            note.setAttribute("data-emphasis", "true");
          }
        });
      } else {
        btn.addEventListener("click", function () {
          state.control = c.id;
          render();
        });
      }
      row.appendChild(btn);
    });
    panel.appendChild(row);

    if (wallBlocked) {
      panel.appendChild(
        el("p", {
          class: "emit-kit-v1__wall-disabled-note",
          id: "emit-kit-v1-control-note",
          text: "Some control options are not currently available in this guided kit path. Your all-in-one recommendation uses the included controller and remote."
        })
      );
    }

    var navRow = el("div", { class: "emit-kit-v1__btn-row" });
    var back = el("button", { class: "emit-kit-v1__btn emit-kit-v1__btn--ghost", type: "button", text: "Back" });
    back.addEventListener("click", goBack);
    var next = el("button", { class: "emit-kit-v1__btn", type: "button", text: "Continue" });
    next.disabled = !state.control;
    next.addEventListener("click", function () {
      goTo("connectors");
    });
    navRow.appendChild(back);
    navRow.appendChild(next);
    panel.appendChild(navRow);

    return panel;
  }


  /* ---------------------------------------------------------------------
   * Step: Connection Pieces
   * ------------------------------------------------------------------- */
  function renderConnectors() {
    var panel = el("div", { class: "emit-kit-v1__panel" });
    panel.appendChild(renderProgress(4, 5));
    panel.appendChild(el("h2", { class: "emit-kit-v1__title", text: "Will you need extra connection pieces?" }));
    panel.appendChild(
      el("p", {
        class: "emit-kit-v1__subtitle",
        text:
          "Many all-in-one kits already include basic connection hardware. Add extras if you plan to cut and rejoin sections, turn corners, or bridge a small gap."
      })
    );

    var stack = el("div", { class: "emit-kit-v1__connector-grid" });

    CONNECTOR_CHOICES.forEach(function (choice) {
      var pressed = state.connectors === choice.id ? "true" : "false";
      var card = el("button", {
        class: "emit-kit-v1__connector-card",
        type: "button",
        "aria-pressed": pressed
      }, [
        el("span", { class: "emit-kit-v1__connector-copy" }, [
          el("strong", { text: choice.label }),
          el("span", { text: choice.sub })
        ]),
        el("span", { class: "emit-kit-v1__connector-status", text: pressed === "true" ? "Selected" : "Select" })
      ]);

      card.addEventListener("click", function () {
        state.connectors = choice.id;
        render();
      });
      stack.appendChild(card);
    });

    panel.appendChild(stack);

    if (state.feel === "tunable" || state.feel === "colors") {
      panel.appendChild(
        el("p", {
          class: "emit-kit-v1__field-note emit-kit-v1__connector-context",
          text:
            "Your current all-in-one kit already includes connection hardware. Extra straight-join connectors can be matched, but some specialty corner/gap connectors are not currently verified for every kit type."
        })
      );
    }

    var navRow = el("div", { class: "emit-kit-v1__btn-row" });
    var back = el("button", {
      class: "emit-kit-v1__btn emit-kit-v1__btn--ghost",
      type: "button",
      text: "Back"
    });
    back.addEventListener("click", goBack);

    var next = el("button", {
      class: "emit-kit-v1__btn",
      type: "button",
      text: "See My Kit"
    });
    next.disabled = !state.connectors;
    next.addEventListener("click", function () {
      goTo("result");
    });

    navRow.appendChild(back);
    navRow.appendChild(next);
    panel.appendChild(navRow);
    return panel;
  }

  /* ---------------------------------------------------------------------
   * Recommendation engine
   * ------------------------------------------------------------------- */
  var FEEL_TO_STRIP_ROLE = {
    warm: "strip_cob_2700",
    warmnatural: "strip_cob_3000",
    neutral: "strip_cob_4000",
    daylight: "strip_cob_5000"
  };
  var FEEL_TO_KIT_CCT = {
    warm: "2700",
    warmnatural: "3000",
    neutral: "4000",
    daylight: "5000"
  };
  var FEEL_LABEL = {
    warm: "warm, cozy",
    warmnatural: "warm, natural",
    neutral: "clean, neutral",
    daylight: "bright daylight"
  };

  function findKitVariantByCct(kitProduct, cct) {
    return kitProduct.variants.find(function (v) {
      return (v.options || []).join(" ").indexOf(cct) !== -1;
    });
  }


  function kitCountForLength(lengthFt, kitLengthFt) {
    var section = kitLengthFt || 16.4;
    return Math.max(1, Math.ceil(Number(lengthFt || section) / section));
  }

  function multiKitRecommendation(product, variant, lengthFt, includedNote, detailNote) {
    if (!product || !variant || !variant.available) return null;
    var qty = kitCountForLength(lengthFt, 16.4);
    return {
      type: "multi_kit",
      product: product,
      variant: variant,
      qty: qty,
      sectionFt: 16.4,
      coverageFt: qty * 16.4,
      explain:
        "You can cover about " +
        lengthFt +
        " ft by dividing the project into " +
        qty +
        " independently powered kit sections. Each section uses its own matched power and controls.",
      includedNote: includedNote,
      detailNote: detailNote || null
    };
  }

  function fixedWhiteMultiKit(lengthFt, cct) {
    var fixedKit = CATALOG.kit_fixed_remote;
    var kitVariant = fixedKit ? findKitVariantByCct(fixedKit, cct) : null;
    if (!kitVariant || !kitVariant.available) return null;
    return multiKitRecommendation(
      fixedKit,
      kitVariant,
      lengthFt,
      "Includes: COB strip, 24V power supply, remote, and connectors.",
      "Each kit section operates independently with its own power supply and remote."
    );
  }

  function bringOwnPowerRecommendation(lengthFt, stripRole, feelLabel) {
    var target = lengthFt <= 16.4 ? 16.4 : 25;
    var stripPick = pickStripVariant(CATALOG[stripRole], target);

    if (!stripPick.variant) {
      return {
        type: "choice",
        headline: "Bring-your-own-power is possible, but we couldn’t match an in-stock strip.",
        reason:
          "Your project can still use an external battery or power system, but this guided path does not currently have a matching in-stock lighting variant.",
        choices: [
          { id: "system", label: "Use LED System Builder", href: CONFIG.systemBuilderUrl, primary: true },
          { id: "back", label: "Change My Answers", action: "back" }
        ]
      };
    }

    var reelFt = variantLengthFt(stripPick.variant) || target;
    var qty = Math.max(1, Math.ceil(lengthFt / reelFt));

    return {
      type: "byo_power",
      product: CATALOG[stripRole],
      variant: stripPick.variant,
      qty: qty,
      reelFt: reelFt,
      coverageFt: qty * reelFt,
      explain:
        "We can provide the " +
        feelLabel +
        " lighting without adding an EMITEVER power supply. " +
        (qty > 1
          ? "For this length, we selected " + qty + " strip reels/sections. "
          : "") +
        "Your external power source is responsible for providing the correct regulated 24V DC output and enough capacity for the connected lighting.",
      lengthSubstitutionNote: stripPick.substituted
        ? "Your exact requested reel length wasn’t available, so we selected the closest in-stock strip length (" + reelFt + " ft) and adjusted the quantity."
        : null
    };
  }


  function firstAvailableVariant(product) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (v) { return v.available; }) || null;
  }

  function pick8mmCornerVariant(product) {
    if (!product || !product.variants) return null;
    var preferred = product.variants.find(function (v) {
      var text = ((v.options || []).join(" ") + " " + (v.title || "")).toLowerCase();
      return v.available && /8\s*mm/.test(text) && /corner/.test(text);
    });
    return preferred || firstAvailableVariant(product);
  }

  function isFixedWhiteRecommendation(rec) {
    if (!rec) return false;
    if (rec.product && rec.product.role === "kit_fixed_remote") return true;
    if (rec.product && /^strip_cob_/.test(rec.product.role || "")) return true;
    if (rec.items && rec.items.some(function (item) {
      return item.product && /^strip_cob_/.test(item.product.role || "");
    })) return true;
    return false;
  }

  function applyConnectorSelection(rec) {
    if (!rec || rec.type === "choice" || !state.connectors) return rec;

    var choice = state.connectors;
    var isFixed = isFixedWhiteRecommendation(rec);
    var isAllInOne = rec.product && /^kit_/.test(rec.product.role || "");

    rec.accessoryItems = rec.accessoryItems || [];

    if (choice === "none") {
      if (isAllInOne) {
        rec.connectorNote = "Your all-in-one kit already includes basic connection hardware, so no extra connector pack was added.";
      }
      return rec;
    }

    if (choice === "notsure") {
      rec.connectorNote = isAllInOne
        ? "Your all-in-one kit already includes basic connection hardware. We left extra connectors out for now so you only buy them if your layout actually needs them."
        : "We left extra connectors out because your layout is still open-ended. You can add a connector pack later once you know whether you need joins, corners, or a gap extension.";
      return rec;
    }

    var product = null;
    var variant = null;
    var reason = "";

    if (choice === "join") {
      product = CATALOG.connector_join;
      variant = firstAvailableVariant(product);
      reason = "For reconnecting compatible 8mm strip sections after cutting.";
    } else if (choice === "corner") {
      if (isFixed) {
        product = CATALOG.connector_corner;
        variant = pick8mmCornerVariant(product);
        reason = "Adds a clean 90° turn for compatible 8mm fixed-white strip.";
      }
    } else if (choice === "gap") {
      if (isFixed) {
        product = CATALOG.connector_gap;
        variant = firstAvailableVariant(product);
        reason = "Helps bridge a small break between compatible 8mm strip sections.";
      }
    }

    if (!product || !variant) {
      rec.connectorNote =
        "No extra connector is currently verified in this guided builder for that exact connection need and lighting type. Your main kit recommendation is still valid.";
      return rec;
    }

    rec.accessoryItems.push({
      role: "Extra Connector",
      product: product,
      variant: variant,
      qty: 1,
      reason: reason
    });

    rec.connectorNote =
      "We added one compatible connector pack for the layout you described. You can adjust the quantity in your cart if your project needs more connection points.";

    return rec;
  }

  function computeRecommendation() {
    var lengthFt = state.lengthFt || 16.4;

    if (state.flags.argb) {
      var ambientRgb = CATALOG.kit_rgb;
      var ambientVariant = ambientRgb && ambientRgb.variants ? ambientRgb.variants[0] : null;
      return {
        type: "choice",
        headline: "PC-synced / addressable control isn’t in this kit path yet.",
        reason: "We don’t currently offer motherboard-synced or addressable RGB through this guided builder. If ambient color is enough, our all-in-one RGB kit is the closest current option.",
        alternativeKit: ambientRgb && ambientVariant && ambientVariant.available ? { product: ambientRgb, variant: ambientVariant, qty: kitCountForLength(lengthFt, 16.4), note: "Each RGB kit operates as its own independently powered section." } : null,
        choices: [
          { id: "ambient", label: "Use RGB Kit Instead", action: "use_alternative", primary: true },
          { id: "back", label: "Change My Project", action: "back" }
        ]
      };
    }

    if (state.flags.outdoor) {
      return {
        type: "choice",
        headline: "Outdoor-rated kit matching isn’t available here yet.",
        reason: "Your project can absolutely use outdoor-rated lighting, but this guided kit path does not currently include a verified outdoor power-and-control bundle. We can keep you in EMITEVER without pretending an indoor kit is suitable.",
        choices: [
          { id: "outdoor", label: "Browse Outdoor & Wet Lighting", href: "/collections/outdoor-wet-location-led-lighting", primary: true },
          { id: "system", label: "Plan the Full Outdoor System", href: CONFIG.systemBuilderUrl },
          { id: "back", label: "Change My Project", action: "back" }
        ]
      };
    }

    if (state.flags.volt48) {
      return {
        type: "choice",
        headline: "You can keep 48V, or switch to kit sections.",
        reason: "The all-in-one kit path is currently built around 24V products. If 48V is important to your project, use the LED System Builder. If not, you can continue with independently powered 24V kit sections.",
        choices: [
          { id: "continue24", label: "Continue With 24V Kits", action: "continue_24", primary: true },
          { id: "system", label: "Keep 48V — Use System Builder", href: CONFIG.systemBuilderUrl }
        ]
      };
    }

    if (state.feel === "colors") {
      var rgbKit = CATALOG.kit_rgb;
      if (!rgbKit || !rgbKit.variants[0] || !rgbKit.variants[0].available) {
        return { type: "choice", headline: "Our RGB all-in-one kit is temporarily unavailable.", reason: "We don’t currently have a standalone RGB strip ecosystem in this guided path, so we won’t substitute unrelated parts.", choices: [{ id: "back", label: "Change My Answers", action: "back", primary: true }, { id: "system", label: "Use LED System Builder", href: CONFIG.systemBuilderUrl }] };
      }
      if (lengthFt > 16.4) {
        return multiKitRecommendation(rgbKit, rgbKit.variants[0], lengthFt, "Includes: RGB COB strip, 24V power supply, remote/receiver, and connection hardware.", "EMITEVER currently offers color-changing lighting here as a complete 16.4 ft kit. Longer projects can use multiple separate kits; each section has its own power and controller.");
      }
      return { type: "kit", product: rgbKit, variant: rgbKit.variants[0], explain: "You’re set up for color. This all-in-one kit already includes the RGB strip, power supply, and remote.", includedNote: "Includes: RGB COB strip, 24V power supply, remote/receiver, and connection hardware.", lengthNote: Math.abs(lengthFt - 16.4) > 2 ? "This kit ships as one 16.4 ft strip and can be trimmed/cut to fit your space." : null };
    }

    if (state.feel === "tunable") {
      var tKit = CATALOG.kit_tunable;
      if (!tKit || !tKit.variants[0] || !tKit.variants[0].available) {
        return { type: "choice", headline: "Our Adjustable White all-in-one kit is temporarily unavailable.", reason: "This lighting type is still possible, but this guided path does not currently have an in-stock complete kit to recommend.", choices: [{ id: "system", label: "Use LED System Builder", href: CONFIG.systemBuilderUrl, primary: true }, { id: "back", label: "Change My Answers", action: "back" }] };
      }
      if (lengthFt > 16.4) {
        return multiKitRecommendation(tKit, tKit.variants[0], lengthFt, "Includes: tunable-white COB strip, 24V power supply, controller, remote, and connectors.", "Each 16.4 ft kit section has its own power supply and controller. For one integrated long-run system, use the LED System Builder instead.");
      }
      return { type: "kit", product: tKit, variant: tKit.variants[0], explain: "This all-in-one kit lets you dial the white color from warm to daylight, with the lighting, power, controller, remote, and connectors already matched.", includedNote: "Includes: tunable-white COB strip, 24V power supply, controller, remote, and connectors.", lengthNote: Math.abs(lengthFt - 16.4) > 2 ? "This kit ships as one 16.4 ft strip and can be trimmed/cut to fit your space." : null };
    }

    var stripRole = FEEL_TO_STRIP_ROLE[state.feel];
    var cct = FEEL_TO_KIT_CCT[state.feel];
    var feelLabel = FEEL_LABEL[state.feel];

    if (state.flags.bringOwnPower || state.control === "ownpower") return bringOwnPowerRecommendation(lengthFt, stripRole, feelLabel);

    if (state.control === "wall") {
      if (lengthFt > 25) {
        var wallMulti = fixedWhiteMultiKit(lengthFt, cct);
        if (wallMulti) {
          wallMulti.explain = "Your requested Wall Control setup is beyond this guided builder’s current single-section sizing window. You can still cover the project with " + wallMulti.qty + " independently powered all-in-one kit sections, or keep Wall Control and plan the larger system professionally.";
          wallMulti.detailNote = "The multiple-kit option changes the control approach: each kit section uses its included remote. To keep Wall Control across a larger integrated project, use the LED System Builder.";
          return wallMulti;
        }
      }
      var requiredLoad = lengthFt * 4;
      var wallProduct = CATALOG.wall_control;
      var wallVariant = pickPowerVariant(wallProduct, requiredLoad, isTwentyFourVolt);
      var stripPick = pickStripVariant(CATALOG[stripRole], lengthFt <= 20 ? 16.4 : 25);
      if (wallVariant && stripPick.variant) {
        return { type: "custom", explain: "You told us you need about " + lengthFt + " ft of " + feelLabel + " lighting with Wall Control. Wall Control replaces a standard wall switch and requires household electrical wiring; no separate power supply is needed.", items: [{ role: "Lighting", product: CATALOG[stripRole], variant: stripPick.variant, qty: 1, reason: "Selected for the " + feelLabel + " light you wanted, sized to your run." }, { role: "Wall Control", product: wallProduct, variant: wallVariant, qty: 1, reason: "Sized with headroom for this run and designed to replace the separate driver/power supply." }], lengthSubstitutionNote: stripPick.substituted ? "Your exact requested length wasn’t in stock, so we selected the closest available strip length (" + stripPick.actualFt + " ft)." : null };
      }
      var wallFallback = fixedWhiteMultiKit(lengthFt, cct);
      if (wallFallback) {
        wallFallback.explain = "We couldn’t confidently size the requested Wall Control setup from the current guided product pool. You can still build the project with independently powered all-in-one kit sections, or keep Wall Control and use the LED System Builder.";
        wallFallback.detailNote = "The multiple-kit option uses the remote included with each kit. Choose the LED System Builder if Wall Control is a requirement.";
        return wallFallback;
      }
    }

    if (state.control === "remote" || state.control === "notsure") {
      var fixedKit = CATALOG.kit_fixed_remote;
      var kitVariant = fixedKit ? findKitVariantByCct(fixedKit, cct) : null;
      if (kitVariant && kitVariant.available) {
        if (lengthFt > 16.4) return multiKitRecommendation(fixedKit, kitVariant, lengthFt, "Includes: COB strip, 24V power supply, remote, and connectors.", "Each kit section operates independently with its own power supply and remote. For one integrated long-run system, use the LED System Builder.");
        return { type: "kit", product: fixedKit, variant: kitVariant, explain: "You told us you need about " + lengthFt + " ft of " + feelLabel + " lighting" + (state.control === "remote" ? " with a remote" : "") + ". This all-in-one kit already has the lighting, power, remote, and connectors matched together.", includedNote: "Includes: COB strip, 24V power supply, remote, and connectors.", lengthNote: Math.abs(lengthFt - 16.4) > 2 ? "This kit ships as one 16.4 ft strip and can be trimmed/cut to fit your space." : null };
      }
    }

    var targetStripLength = lengthFt <= 16.4 ? 16.4 : 25;
    var plugStrip = pickStripVariant(CATALOG[stripRole], targetStripLength);
    var plugPsu = pickPowerVariant(CATALOG.psu_nondimmable, lengthFt * 4, function (v) { return !isTwoPack(v); });

    if (plugStrip.variant && plugPsu && lengthFt <= 25) {
      return { type: "custom", explain: "You told us you need about " + lengthFt + " ft of " + feelLabel + " lighting with a simple plug in setup. We matched the strip and power supply for you.", items: [{ role: "Lighting", product: CATALOG[stripRole], variant: plugStrip.variant, qty: 1, reason: "Selected for the " + feelLabel + " light you wanted." }, { role: "Power", product: CATALOG.psu_nondimmable, variant: plugPsu, qty: 1, reason: "Sized automatically for this run with Emitever’s recommended 20% power headroom." }], lengthSubstitutionNote: plugStrip.substituted ? "Your exact requested length wasn’t in stock, so we selected the closest available strip length (" + plugStrip.actualFt + " ft)." : null };
    }

    var multi = fixedWhiteMultiKit(lengthFt, cct);
    if (multi) {
      multi.explain = "One plug-in section is not the cleanest fit for about " + lengthFt + " ft under our current guided power-sizing rules. You can divide the project into " + multi.qty + " all-in-one kit sections, or use the LED System Builder for one integrated system.";
      multi.detailNote = "Each kit section has its own matched power supply and remote. The LED System Builder is the better choice if you want centralized power or one integrated control plan.";
      return multi;
    }

    return { type: "choice", headline: "We can keep planning this project.", reason: "The exact single-section configuration isn’t available in this guided path right now. You can change an answer or move into the LED System Builder without losing the project direction.", choices: [{ id: "back", label: "Change My Answers", action: "back", primary: true }, { id: "system", label: "Use LED System Builder", href: CONFIG.systemBuilderUrl }] };
  }

  /* ---------------------------------------------------------------------
   * Step: Result
   * ------------------------------------------------------------------- */
  function renderChoiceCard(panel, rec) {
    panel.appendChild(el("h2", { class: "emit-kit-v1__title emit-kit-v1__center", text: rec.headline || "Choose the path that fits your project." }));
    var card = el("div", { class: "emit-kit-v1__decision-card" });
    card.appendChild(el("p", { class: "emit-kit-v1__decision-copy", text: rec.reason || "" }));

    if (rec.alternativeKit) {
      var alt = rec.alternativeKit;
      var altWrap = el("div", { class: "emit-kit-v1__decision-preview" });
      altWrap.appendChild(buildLineItem("Current Alternative", alt.product, alt.variant, alt.note || ""));
      altWrap.appendChild(el("p", { class: "emit-kit-v1__field-note", text: "For about " + (state.lengthFt || 16.4) + " ft, this would use " + alt.qty + " independently powered kit section" + (alt.qty === 1 ? "." : "s.") }));
      card.appendChild(altWrap);
    }

    var actions = el("div", { class: "emit-kit-v1__decision-actions" });
    (rec.choices || []).forEach(function (choice) {
      var attrs = { class: "emit-kit-v1__btn" + (choice.primary ? "" : " emit-kit-v1__btn--ghost"), text: choice.label };
      var control;
      if (choice.href) {
        attrs.href = choice.href;
        control = el("a", attrs);
      } else {
        attrs.type = "button";
        control = el("button", attrs);
        control.addEventListener("click", function () {
          if (choice.action === "back") return goBack();
          if (choice.action === "continue_24") {
            state.flags.volt48 = false;
            return render();
          }
          if (choice.action === "use_alternative" && rec.alternativeKit) {
            var alt = rec.alternativeKit;
            return renderRecommendation(panel, {
              type: alt.qty > 1 ? "multi_kit" : "kit",
              product: alt.product,
              variant: alt.variant,
              qty: alt.qty,
              coverageFt: alt.qty * 16.4,
              explain: alt.qty > 1 ? "This uses " + alt.qty + " independently powered RGB kit sections for ambient color. It does not add addressable or motherboard-synced control." : "This gives you ambient color with the current all-in-one RGB kit. It does not add addressable or motherboard-synced control.",
              includedNote: "Includes: RGB COB strip, 24V power supply, remote/receiver, and connection hardware.",
              detailNote: alt.note || null
            }, true);
          }
        });
      }
      actions.appendChild(control);
    });
    card.appendChild(actions);
    panel.appendChild(card);
    panel.appendChild(restartRow());
  }

  function renderRecommendation(panel, rec, replacePanel) {
    if (replacePanel) panel.innerHTML = "";
    var head = el("div", { class: "emit-kit-v1__result-head" });
    head.appendChild(el("p", { class: "emit-kit-v1__result-badge", text: rec.type === "multi_kit" ? "Your Kit Plan" : "Your Kit" }));
    head.appendChild(el("h2", { class: "emit-kit-v1__title", text: rec.type === "kit" ? "You’re set." : rec.type === "multi_kit" ? "You can absolutely build it with kits." : rec.type === "byo_power" ? "We’ll handle the lighting side." : "Here’s the system we chose for you." }));
    head.appendChild(el("p", { class: "emit-kit-v1__result-explain", text: rec.explain }));
    panel.appendChild(head);

    var card = el("div", { class: "emit-kit-v1__result-card" });
    var total = 0;
    var cartPayload = [];

    if (rec.type === "kit") {
      card.appendChild(el("div", { class: "emit-kit-v1__result-card-label", text: "Complete Kit — Everything You Need" }));
      card.appendChild(buildLineItem("Kit", rec.product, rec.variant, rec.includedNote));
      total = Number(rec.variant.price || 0);
      cartPayload = [{ id: rec.variant.id, quantity: 1 }];
      if (rec.lengthNote) card.appendChild(el("p", { class: "emit-kit-v1__field-note", text: rec.lengthNote }));
    } else if (rec.type === "multi_kit") {
      var qty = rec.qty || 1;
      card.appendChild(el("div", { class: "emit-kit-v1__result-card-label", text: "Multiple All-in-One Kits" }));
      card.appendChild(buildLineItem(qty + " × Kit", rec.product, rec.variant, rec.includedNote));
      total = Number(rec.variant.price || 0) * qty;
      cartPayload = [{ id: rec.variant.id, quantity: qty }];
      card.appendChild(el("div", { class: "emit-kit-v1__coverage-note" }, [el("strong", { text: qty + " independent kit sections" }), el("span", { text: " Covers up to about " + (rec.coverageFt || qty * 16.4).toFixed(1).replace(".0", "") + " ft. Each section has its own power and controls." })]));
      if (rec.detailNote) card.appendChild(el("p", { class: "emit-kit-v1__field-note", text: rec.detailNote }));
    } else if (rec.type === "byo_power") {
      card.appendChild(el("div", { class: "emit-kit-v1__result-card-label", text: "Lighting Only — You Supply the Power" }));
      card.appendChild(buildLineItem((rec.qty || 1) > 1 ? (rec.qty + " × Lighting") : "Lighting", rec.product, rec.variant, "Selected for your project without adding an EMITEVER power supply."));
      total = Number(rec.variant.price || 0) * (rec.qty || 1);
      cartPayload = [{ id: rec.variant.id, quantity: rec.qty || 1 }];
      card.appendChild(
        el("div", { class: "emit-kit-v1__coverage-note emit-kit-v1__coverage-note--caution" }, [
          el("strong", { text: "Bring Your Own Power" }),
          el("span", {
            text:
              " " +
              ((rec.qty || 1) > 1
                ? (rec.qty + " strip sections cover up to about " + Number(rec.coverageFt || 0).toFixed(1).replace(".0", "") + " ft. ")
                : "") +
              "Your external source must provide regulated 24V DC and sufficient capacity for the connected lighting. This builder does not design or size the battery/power system."
          })
        ])
      );
      if (rec.lengthSubstitutionNote) card.appendChild(el("p", { class: "emit-kit-v1__field-note", text: rec.lengthSubstitutionNote }));
    } else {
      card.appendChild(el("div", { class: "emit-kit-v1__result-card-label", text: "Your Custom Kit" }));
      rec.items.forEach(function (item) {
        card.appendChild(buildLineItem(item.role, item.product, item.variant, item.reason));
        total += Number(item.variant.price || 0) * Number(item.qty || 1);
        cartPayload.push({ id: item.variant.id, quantity: item.qty || 1 });
      });
      if (rec.lengthSubstitutionNote) card.appendChild(el("p", { class: "emit-kit-v1__field-note", text: rec.lengthSubstitutionNote }));
      if (rec.controlNote) card.appendChild(el("p", { class: "emit-kit-v1__field-note", text: rec.controlNote }));
    }

    if (rec.accessoryItems && rec.accessoryItems.length) {
      card.appendChild(el("div", { class: "emit-kit-v1__result-card-label emit-kit-v1__result-card-label--accessory", text: "Installation Extra" }));
      rec.accessoryItems.forEach(function (item) {
        card.appendChild(buildLineItem(item.role, item.product, item.variant, item.reason));
        total += Number(item.variant.price || 0) * Number(item.qty || 1);
        cartPayload.push({ id: item.variant.id, quantity: item.qty || 1 });
      });
    }

    if (rec.connectorNote) {
      card.appendChild(el("p", { class: "emit-kit-v1__field-note emit-kit-v1__connector-result-note", text: rec.connectorNote }));
    }

    card.appendChild(el("div", { class: "emit-kit-v1__result-total" }, [el("span", { text: rec.type === "multi_kit" ? "Estimated total for all kits" : "Estimated total" }), el("span", { text: money(total) })]));
    panel.appendChild(card);

    var details = el("details", { class: "emit-kit-v1__details" });
    details.appendChild(el("summary", { text: "Why this works" }));
    var ul = el("ul");
    var detailItems = rec.type === "kit"
      ? [
          "The strip, power, and controls in this kit are already matched to work together.",
          "The 24V low-voltage setup keeps the lighting side straightforward for a dry indoor project.",
          rec.accessoryItems && rec.accessoryItems.length
            ? "The extra connector was matched to the layout choice you made."
            : "The kit already includes the core connection hardware needed to get started."
        ]
      : rec.type === "multi_kit"
        ? [
            "Each 16.4 ft kit section arrives with its own matched lighting, power, and controls.",
            "Using separate powered sections lets the project scale without changing the way each kit is installed.",
            "If you prefer one centralized power/control layout instead, the LED System Builder can plan that version."
          ]
        : rec.type === "byo_power"
          ? [
              "We matched the lighting to the color and length you chose while leaving the power source out of the cart.",
              "The selected strip uses 24V low-voltage DC power.",
              "Your external battery or power system needs to provide the correct regulated voltage and enough capacity for the lighting you connect."
            ]
          : [
              "The lighting and power components were matched for the length and light color you selected.",
              "The power recommendation follows Emitever’s 20% headroom rule.",
              rec.accessoryItems && rec.accessoryItems.length
                ? "The extra connector was selected for the installation layout you described."
                : "No unnecessary installation extras were added."
            ];
    detailItems.forEach(function (t) { ul.appendChild(el("li", { text: t })); });
    details.appendChild(ul);
    panel.appendChild(details);

    var addRow = el("div", { class: "emit-kit-v1__btn-row emit-kit-v1__result-actions" });
    var addBtn = el("button", { class: "emit-kit-v1__btn", type: "button", text: rec.type === "multi_kit" ? "Add All " + (rec.qty || 1) + " Kits to Cart" : "Add Your Kit to Cart" });
    addBtn.addEventListener("click", function () { addToCart(cartPayload, addBtn); });
    addRow.appendChild(addBtn);
    if (rec.type === "multi_kit") addRow.appendChild(el("a", { class: "emit-kit-v1__btn emit-kit-v1__btn--ghost", href: CONFIG.systemBuilderUrl, text: "Plan One Integrated System Instead" }));
    panel.appendChild(addRow);
    panel.appendChild(restartRow());
  }

  function renderResult() {
    var rec = applyConnectorSelection(computeRecommendation());
    var panel = el("div", { class: "emit-kit-v1__panel" });
    if (rec.type === "choice") {
      renderChoiceCard(panel, rec);
      return panel;
    }
    renderRecommendation(panel, rec, false);
    return panel;
  }

  function buildLineItem(roleLabel, product, variant, reason) {
    var oos = !variant.available;
    var img = el("div", { class: "emit-kit-v1__line-thumb" }, [el("img", { src: product.image || "", alt: product.title, loading: "lazy" })]);
    var body = el("div", { class: "emit-kit-v1__line-body" }, [
      el("span", { class: "emit-kit-v1__line-role", text: roleLabel }),
      el("a", { href: product.url }, [el("strong", { text: product.title })]),
      el("span", { class: "emit-kit-v1__line-reason", text: reason || "" })
    ]);
    if (oos) body.appendChild(el("span", { class: "emit-kit-v1__line-oos", text: "Currently out of stock" }));
    var price = el("div", { class: "emit-kit-v1__line-price", text: money(Number(variant.price || 0)) });
    return el("div", { class: "emit-kit-v1__line-item" }, [img, body, price]);
  }

  function restartRow() {
    var row = el("div", { class: "emit-kit-v1__btn-row emit-kit-v1__center", style: "justify-content:center;" });
    var back = el("button", { class: "emit-kit-v1__btn emit-kit-v1__btn--ghost", type: "button", text: "Change an Answer" });
    back.addEventListener("click", goBack);
    var restartBtn = el("button", { class: "emit-kit-v1__btn--link", type: "button", text: "Start Over" });
    restartBtn.addEventListener("click", restart);
    row.appendChild(back);
    row.appendChild(restartBtn);
    return row;
  }

  function showToast(msg) {
    var toast = ROOT.querySelector(".emit-kit-v1__toast");

    if (!toast) {
      toast = el("div", {
        class: "emit-kit-v1__toast"
      });

      ROOT.appendChild(toast);
    }

    toast.textContent = msg;
    toast.setAttribute("data-visible", "true");

    clearTimeout(toast._t);

    toast._t = setTimeout(function () {
      toast.setAttribute("data-visible", "false");
    }, 3200);
  }


  /* ---------------------------------------------------------------------
   * Native theme cart drawer integration
   * ------------------------------------------------------------------- */

  function openNativeCartDrawer() {
    var drawer = document.querySelector("cart-drawer");

    if (!drawer) {
      return false;
    }

    /*
     * The current Emitever theme uses a <modal-container> inside
     * <cart-drawer>. Prefer the theme's own open() method when available.
     */
    var modal = drawer.querySelector("modal-container");

    if (modal && typeof modal.open === "function") {
      modal.open();
      return true;
    }

    /*
     * Fallback:
     * use the theme's normal cart-drawer trigger if the custom element
     * doesn't expose its open() method yet.
     */
    var opener = document.querySelector(
      'modal-open[target="cart-drawer"]'
    );

    if (opener && typeof opener.click === "function") {
      opener.click();
      return true;
    }

    return false;
  }


  function refreshNativeCartDrawer() {
    var drawer = document.querySelector("cart-drawer");

    if (!drawer) {
      return Promise.resolve(false);
    }

    /*
     * The theme's cart drawer carries its Shopify section ID directly
     * on the <cart-drawer> element.
     *
     * We request a fresh render of that exact section after the cart
     * has changed.
     */
    var sectionId = drawer.getAttribute("section-id");

    if (!sectionId) {
      openNativeCartDrawer();
      return Promise.resolve(false);
    }

    var sectionUrl = new URL(window.location.href);

    sectionUrl.searchParams.set(
      "section_id",
      sectionId
    );

    return fetch(sectionUrl.toString(), {
      method: "GET",
      headers: {
        Accept: "text/html"
      },
      credentials: "same-origin"
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(
            "Could not refresh cart drawer"
          );
        }

        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(
          html,
          "text/html"
        );

        var freshDrawer =
          doc.querySelector("cart-drawer");

        if (!freshDrawer) {
          throw new Error(
            "Fresh cart drawer markup was not returned"
          );
        }

        /*
         * IMPORTANT:
         *
         * Do NOT replace the actual <cart-drawer> element.
         *
         * The theme's cart-drawer.js custom element already has its
         * event subscriptions attached to this instance.
         *
         * Replacing only the contents gives us fresh Shopify cart
         * markup while preserving the existing component instance.
         */
        drawer.innerHTML =
          freshDrawer.innerHTML;

        /*
         * Give the browser two paint cycles to register the refreshed
         * drawer markup before opening it.
         */
        return new Promise(function (resolve) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              openNativeCartDrawer();
              resolve(true);
            });
          });
        });
      })
      .catch(function (err) {
        /*
         * The Shopify cart itself has already been updated successfully
         * before this function runs.
         *
         * So if refreshing the drawer fails for any reason, do NOT turn
         * the successful add-to-cart into an error.
         *
         * Just try to open the existing drawer as a graceful fallback.
         */
        console.warn(
          "[EMITEVER Kit Builder] Cart drawer refresh failed:",
          err
        );

        openNativeCartDrawer();

        return false;
      });
  }


  function addToCart(items, triggerBtn) {
    if (!items || !items.length) {
      return;
    }

    triggerBtn.disabled = true;

    var originalText =
      triggerBtn.textContent;

    triggerBtn.textContent =
      "Adding…";

    fetch("/cart/add.js", {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },

      body: JSON.stringify({
        items: items
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res
            .json()
            .then(function (j) {
              throw new Error(
                j.description ||
                "Could not add to cart"
              );
            });
        }

        return res.json();
      })

      /*
       * Shopify now has the new products.
       *
       * Refresh the theme's native cart drawer so the customer sees
       * those products immediately without refreshing the page.
       */
      .then(function () {
        return refreshNativeCartDrawer();
      })

      .then(function () {
        showToast(
          "Added to cart."
        );

        triggerBtn.textContent =
          "Added ✓";

        setTimeout(function () {
          triggerBtn.textContent =
            originalText;

          triggerBtn.disabled =
            false;
        }, 2200);
      })

      .catch(function (err) {
        showToast(
          err.message ||
          "Something went wrong adding this kit to your cart."
        );

        triggerBtn.textContent =
          originalText;

        triggerBtn.disabled =
          false;
      });
  }

  /* ---------------------------------------------------------------------
   * Render dispatch
   * ------------------------------------------------------------------- */
  function render() {
    var sameStep = lastRenderedStep === state.step;
    var node;
    switch (state.step) {
      case "application":
        node = renderApplication();
        break;
      case "length":
        node = renderLength();
        break;
      case "feel":
        node = renderFeel();
        break;
      case "control":
        node = renderControl();
        break;
      case "connectors":
        node = renderConnectors();
        break;
      case "result":
        node = renderResult();
        break;
      default:
        node = renderIntro();
    }
    if (sameStep && node) node.classList.add("emit-kit-v1__panel--static");
    STAGE.replaceChildren(node);
    lastRenderedStep = state.step;
  }

  render();
})();